import { render, staticRenderFns } from "./WorkflowMap.vue?vue&type=template&id=63a7bfd8&scoped=true"
import script from "./WorkflowMap.vue?vue&type=script&lang=js"
export * from "./WorkflowMap.vue?vue&type=script&lang=js"
import style0 from "./WorkflowMap.vue?vue&type=style&index=0&id=63a7bfd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a7bfd8",
  null
  
)

export default component.exports